/* 2.5.0 header search sheet (PROTO-2 .hsearch, snippet jp-p2-se-sheet). Opens from any [data-jp-hs-open] or
   window.JPHSearch.open(q). Typing asks Shopify's predictive search through the Section Rendering API
   (section jp-p2-se-predictive): nothing before 2 characters, 300 ms after the last key, the words are never stored
   or sent anywhere else. Enter submits the form to /search, as the live header does. */
(function () {
  'use strict';
  if (window.JPHSearch) return;
  var hs = document.querySelector('[data-jp-hs]'); if (!hs) return;
  var q = hs.querySelector('input[name="q"]'), idle = hs.querySelector('[data-jp-hs-idle]'), res = hs.querySelector('[data-jp-hs-res]');
  var MIN = 2, WAIT = 300, timer = 0, ctl = null, last = '', back = null, calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FIELDS = '&type=product&options%5Bfields%5D=title%2Ctag%2Cproduct_type%2Cvariants.title&options%5Bprefix%5D=last';
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function open(v) {
    back = document.activeElement; hs.hidden = false;
    void hs.offsetWidth;   // style the shown, closed sheet first, so .on transitions in (PROTO-2: fade and slide)
    hs.classList.add('on');
    document.documentElement.style.overflow = 'hidden';
    if (typeof v === 'string') { q.value = v; run(); }
    setTimeout(function () { q.focus(); }, 60);
  }
  function close() {
    hs.classList.remove('on'); document.documentElement.style.overflow = '';
    setTimeout(function () { hs.hidden = true; }, calm ? 0 : 320);
    if (back && back.focus) try { back.focus(); } catch (_) {}
  }
  function paint(v, node) {
    res.textContent = '';
    var go = document.createElement('div'); go.className = 'hs-list';
    go.innerHTML = '<a class="go" href="' + esc(hs.getAttribute('data-search') + '?q=' + encodeURIComponent(v) + FIELDS) + '"><svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="M16 16l4 4"/></svg>See all results for “' + esc(v) + '”</a>';
    res.appendChild(go);
    if (node) res.appendChild(document.importNode(node, true));
  }
  function run() {
    var v = q.value.trim();
    idle.hidden = !!v; res.hidden = !v;
    if (v.length < MIN) { last = ''; if (v) paint(v, null); return; }
    if (v === last) return; last = v;
    paint(v, null);
    if (ctl) ctl.abort(); ctl = window.AbortController ? new AbortController() : null;
    var u = hs.getAttribute('data-suggest') + '?q=' + encodeURIComponent(v) + '&resources%5Btype%5D=product,collection,article,page&resources%5Blimit%5D=10&resources%5Blimit_scope%5D=each&resources%5Boptions%5D%5Bunavailable_products%5D=last&section_id=jp-p2-se-predictive';
    fetch(u, { headers: { Accept: 'text/html' }, credentials: 'same-origin', signal: ctl && ctl.signal })
      .then(function (r) { if (!r.ok) throw new Error('suggest ' + r.status); return r.text(); })
      .then(function (h) { if (q.value.trim() !== v) return; paint(v, new DOMParser().parseFromString(h, 'text/html').querySelector('[data-jp-hs-sg]')); })
      .catch(function () { /* suggestions are optional: the form still submits */ });
  }
  q.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, q.value.trim().length < MIN ? 0 : WAIT); });
  hs.querySelector('[data-jp-hs-close]').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !hs.hidden) close(); });
  document.addEventListener('mousedown', function (e) { if (!hs.hidden && !hs.contains(e.target) && !(e.target.closest && e.target.closest('[data-jp-hs-open]'))) close(); });
  document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-jp-hs-open]'); if (!b) return; e.preventDefault(); open(b.getAttribute('data-q') || undefined); });
  window.JPHSearch = { open: open, close: close };
})();
